module.exports = __webpack_public_path__ + "img/whatsapp.8a99ce00.png";